export default "__VITE_ASSET__D$jzmsuR__"